"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.palette = void 0;

var _colors = require("./colors");

const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

const palette = _colors.colors.reduce((acc, color) => {
  acc[color] = theme => theme[`color${capitalizeFirstLetter(color)}`];

  return acc;
}, {});

exports.palette = palette;